<template>
    <SidebarLayout>
        <template slot="sidebar">
            <div v-if="user" class="card">
                <div class="card-body text-center">
                    <div class="card-img-actions d-inline-block mb-3">
                        <Avatar :name="user.name" :radius="50"/>
                    </div>
                    <h6 class="font-weight-semibold mb-0">{{user.name}}</h6>
                </div>

                <ul class="nav nav-sidebar" data-nav-type="accordion">
                    <li class="nav-item">
                        <router-link :to="{name: 'Applications'}" class="nav-link" active-class="active" exact>
                            <i class="icon-home2"></i> {{$t('profile.nav.applications')}}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'PersonalData'}" class="nav-link" active-class="active" exact>
                            <i class="icon-user"></i> {{$t('profile.nav.profile_details')}}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'EmailBoxes'}" class="nav-link" active-class="active">
                            <i class="icon-envelop"></i> {{$t('profile.nav.email_accounts')}}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'Templates'}" class="nav-link" active-class="active">
                            <i class="icon-insert-template"></i> {{$t('profile.nav.templates')}}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'CredentialsManager'}" class="nav-link" active-class="active">
                            <i class="icon-grid5"></i> {{$t('profile.nav.external_accounts')}}
                        </router-link>
                    </li>
                </ul>

            </div>
        </template>

        <div class="content-wrapper" v-if="user">
            <!-- Content area -->
            <div class="content">
                <router-view></router-view>
            </div>
        </div>

    </SidebarLayout>

</template>

<script>
    import SidebarLayout from "./layouts/SidebarLayout";
    import Avatar from "../components/Utilities/Avatar";
    import {mapGetters} from "vuex";

    export default {
        name: "Profile",
        components: {SidebarLayout, Avatar},
        computed: {
            ...mapGetters('Auth', ['user'])
        }
    }
</script>
